var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
var SvgToolsIcon = function (props) { return (_jsx("svg", __assign({ width: 33, height: 32, viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "m21.705 17.547-2.828 2.828 7.995 7.995 2.828-2.828-7.995-7.995ZM23.833 13.48A4.672 4.672 0 0 0 28.5 8.813c0-.773-.213-1.493-.547-2.133l-3.6 3.6-1.987-1.987 3.6-3.6a4.607 4.607 0 0 0-2.133-.547 4.672 4.672 0 0 0-4.666 4.667c0 .547.106 1.067.28 1.547l-2.467 2.466-2.373-2.373.946-.947-1.88-1.88L16.5 4.8a4 4 0 0 0-5.653 0l-4.72 4.72 1.88 1.88h-3.76l-.947.946 4.72 4.72.946-.946v-3.774l1.88 1.88.947-.946 2.373 2.373-9.88 9.88 2.827 2.827L22.287 13.2c.48.173 1 .28 1.546.28Z", fill: "#fff" }) }))); };
var Memo = memo(SvgToolsIcon);
export default Memo;
//# sourceMappingURL=ToolsIcon.js.map